import Link from 'next/link'
import { DoctorForUser } from 'api-client/contracts/doctor'

import Text from '@/components/atomic/atoms/Text'
import Icon from '@/components/cell/atoms/Icon'
import { IconPack } from '@/components/cell/atoms/Icon/enum'
import COLOR from '@/components/cell/designTokens/color'
import { StarRating } from '@/shared/components/star-rating'

interface Props {
  doctor: DoctorForUser
  defaultText?: {
    doctor?: string
    ceo?: string
    review?: string
  }
  handleClick?: () => void
}

export const DoctorProfile = ({
  doctor,
  defaultText = { doctor: '원장', ceo: '대표원장', review: '후기' },
  handleClick,
}: Props) => {
  return (
    <div
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          handleClick && handleClick()
        }
      }}
      role="button"
      onClick={handleClick}
    >
      <Link href={`/doctors/${doctor.doctorId}`} target="_blank" data-testid="doctor-profile">
        <div className="flex items-center text-decoration-none text-inherit">
          <img
            src={doctor.profileImageUrl}
            className="doctorImage rounded-[64px] w-[64px] h-[64px] mr-[16px] object-cover"
            alt={doctor.name}
          />
          <div className="doctorIdentity flex flex-col h-[64px] justify-center">
            {/* 의사 전공) 가정의학과, 피부과 등.. */}
            {!!doctor.majorName && (
              <span className="doctorMajor flex items-center gap-[2px]">
                <Icon name={IconPack.GENERAL_CERTIFICATION_DOCTOR_LATTE} width={15} height={15} viewBox="0 0 24 24" />
                <Text type="caption3" color={COLOR.latte} className="mt-[1px]">
                  {doctor.majorName}
                </Text>
              </span>
            )}
            {/* doctor 이름 */}
            <span className="doctorName mt-[4px]">
              <Text type="title4" element="h3">
                {doctor.name} {doctor.chief ? defaultText.ceo : defaultText.doctor}{' '}
              </Text>
            </span>

            <div className="flex items-center">
              {/* doctor Rating */}
              {!!doctor.statistics?.rating && <StarRating rating={doctor.statistics?.rating} digit={1} />}

              {/* Doctor 후기 개수 */}
              {!!doctor.statistics?.reviewCount && (
                <Text type="caption2" color={COLOR.gray800}>
                  ・ {defaultText.review} {doctor.statistics?.reviewCount.toLocaleString()}
                </Text>
              )}
            </div>
          </div>
        </div>
      </Link>
    </div>
  )
}
